import workingStepLogo from "static/images/landing-page/workingStepLogo.svg";

export default function TimePhasingWorkingSteps() {
  const WorkingStep = ({
    step,
    heading,
    content,
  }: {
    step: number;
    heading: string;
    content: string;
  }) => {
    return (
      <div>
        <div className="flex text-2xl items-center mb-4">
          <div className="bg-primaryRed text-white font-bold rounded-10px px-3.5 py-1.5 leading-29px mr-4">
            {step}
          </div>
          <span className="font-extrabold leading-6">{heading}</span>
        </div>
        <div className="font-medium max-w-540px">{content}</div>
      </div>
    );
  };

  return (
    <div className="flex border border-promGray2 rounded-lg p-5 md:p-10 lg:p-14 bg-white">
      <div className="w-full xxl:w-2/3 space-y-10">
        <WorkingStep
          step={1}
          heading="Input"
          content="Provide timePhasing with existing data from project schedule
          software and / or project budget to get started. This can be one single
          project or a portfolio of projects, and be sourced from one or more
          scheduling tools (e.g. Primavera, Safran, Microsoft Project and even
          Excel)."
        />

        <WorkingStep
          step={2}
          heading="Phasing magic"
          content="The service calculates accurate time-phased values based on activities, calendars, profiles and grouping logic you define."
        />

        <WorkingStep
          step={3}
          heading="Output"
          content="Accurate period values are returned to you, ready to be
          visualised by any BI platform."
        />
      </div>
      <div className="w-1/3 hidden xxl:flex items-center justify-center">
        <img src={workingStepLogo} alt="working" />
      </div>
    </div>
  );
}
